import { ObservableService } from '@damofire/data-angular-commons';
import { Issue } from '../issue/issue.dto';
import { Note } from './note.dto';
import { Asset } from '../asset/asset.dto';
import { Inspection } from '../inspection/inspection.dto';

export function getIssueDescription(issue: Issue): { descriptionEn: string; descriptionFr: string } {
  let descriptionEn = issue.component.descriptionEn;
  let descriptionFr = issue.component.descriptionFr;

  if (issue.equipment) {
    descriptionEn += `, ${issue.equipment}`;
    descriptionFr += `, ${issue.equipment}`;
  }

  if (issue.description.description !== 'OTHER') {
    descriptionEn += `, ${issue.description.descriptionEn}`;
    descriptionFr += `, ${issue.description.descriptionFr}`;
  }

  if (issue.description.description === 'OTHER' && issue.issue) {
    descriptionEn += `, ${issue.issue.slice(0, 50)}`;
    descriptionFr += `, ${issue.issue.slice(0, 50)}`;
  }
  return { descriptionEn, descriptionFr };
}

export abstract class NoteService extends ObservableService<Note> {
  abstract createForIssue(note: string, issue: Issue): Promise<void>;
  abstract createForIssueBatch(notes: string[], issue: Issue): Promise<void>;
  abstract createForAsset(note: string, asset: Asset, inspection: Inspection): Promise<void>;
  abstract delete(division: string, id: string): Promise<void>;
  abstract update(note: Note, text: string): Promise<void>;
}
